
import { AppState } from './../../state/index';
export const selectInjectedData = (state: AppState) => state.injectedHookData;